export default "__VITE_ASSET__o_o_a0w1__"